import { Service } from './Service';
import { ErrorWrapper, ResponseWrapper } from '@/services/util';

export class BaseService extends Service {
  static get endpoint() {
    return 'base';
  }

  static async getStatuses() {
    try {
      const response = await this.request({ auth: true }).get(
        `${this.endpoint}/statuses`
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
}
